import React, { useState } from 'react';
import "../styles/contact.css";
import { FaMapMarker, FaEnvelope, FaPhone } from 'react-icons/fa';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import { Slide } from '@mui/material';
const Contact = () => {
  const [formData, setFormData] = useState({
    emri: "",
    emaili: "",
    website: "",
    nrTelefonit: "",
    mesazhi: "",
  });

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");


  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch("https://d3ejxze7429gw1.cloudfront.net/submit-form", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      const result = await response.json();

      if (response.ok) {
        setSnackbarMessage("Form submitted successfully!");
        setSnackbarSeverity("success");
      } else {
        setSnackbarMessage(result.message || "Failed to submit form.");
        setSnackbarSeverity("error");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      setSnackbarMessage("An error occurred. Please try again.");
      setSnackbarSeverity("error");
    } finally {
      setSnackbarOpen(true);
    }
  };

  const handleCloseSnackbar = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setSnackbarOpen(false);
  };


  // Function to handle address click (opens Google Maps)
  const handleAddressClick = () => {
    const address = "Objekti BK Center(Kati 1), Rr. 'Ismail Raka' - Kasapnik 71000";
    const googleMapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`;
    window.open(googleMapsUrl, "_blank");
  };

  // Function to handle email click (opens default email client)
  const handleEmailClick = () => {
    const email = "ronniceramics@gmail.com";
    const mailtoUrl = `mailto:${email}`;
    window.location.href = mailtoUrl;
  };

  // Function to handle phone number click (opens phone app)
  const handlePhoneClick = (phoneNumber) => {
    const telUrl = `tel:${phoneNumber}`;
    window.location.href = telUrl;
  };

  return (
    <div>
      {/* Hero Section */}
      <div className="contact-hero">
        <div className="overlay"></div>
        <div className="contact-content">
          <h1 className="contact-title">Na kontaktoni</h1>
          <p className="contact-text">
            Tek Ronniceramics, ne marrim frymëzim nga trendet më të fundit të dizajnit global, duke i dhënë formë çdo detaji me pasion dhe mjeshtëri. Çdo krijim është një simbiozë perfekte mes artit dhe funksionalitetit, ku materialet cilësore dhe estetika bashkohen për të sjellë elegancë të përjetshme në hapësirën tuaj.
          </p>
        </div>
      </div>

      {/* Contact Form Section */}
      <div className="contact-form-section">
      <h2 className="form-title">Na shënoni!</h2>
      <form className="contact-form" onSubmit={handleSubmit}>
        <div className="form-group">
          <input
            type="text"
            name="emri"
            placeholder="Emri"
            value={formData.emri}
            onChange={handleChange}
            required
          />
          <input
            type="email"
            name="emaili"
            placeholder="E-Mail"
            value={formData.emaili}
            onChange={handleChange}
            required
          />
        </div>
        <div className="form-group">
          <input
            type="text"
            name="nrTelefonit"
            placeholder="Numri i telefonit"
            value={formData.nrTelefonit}
            onChange={handleChange}
            required
          />
          <input
            type="text"
            name="website"
            placeholder="Faqja juaj e internetit"
            value={formData.website}
            onChange={handleChange}
          />
        </div>
        <textarea
          name="mesazhi"
          placeholder="Mesazhi juaj këtu"
          value={formData.mesazhi}
          onChange={handleChange}
          required
        ></textarea>
        <button type="submit" className="submit-btn">
          PARAQISNI TANI
        </button>
      </form>

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        TransitionComponent={Slide}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert onClose={handleCloseSnackbar} severity={snackbarSeverity} sx={{ width: '100%' }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </div>

      {/* Contact Information Section */}
      <div className="contact-info-section">
        {/* Address Card */}
        <div className="contact-card" onClick={handleAddressClick} style={{ cursor: "pointer" }}>
          <FaMapMarker className="contact-card-icon" />
          <h3>Lokacioni</h3>
          <p>
            Objekti BK Center(Kati 1), Rr. "Ismail Raka" - Kasapnik 71000
          </p>
        </div>

        {/* Email Card */}
        <div className="contact-card" onClick={handleEmailClick} style={{ cursor: "pointer" }}>
          <FaEnvelope className="contact-card-icon" />
          <h3>Email</h3>
          <p>ronniceramics@gmail.com</p>
        </div>

        {/* Phone Card */}
        <div className="contact-card">
          <FaPhone className="contact-card-icon" />
          <h3>Na Thirrni</h3>
          <p>
            <span onClick={() => handlePhoneClick("+38344539551")} style={{ cursor: "pointer" }}>
              +38344539551
            </span>
            <br />
            <span onClick={() => handlePhoneClick("+38344174889")} style={{ cursor: "pointer" }}>
              +38344174889
            </span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Contact;